import { fetcher } from "../fetcher";

type GetDocumentsParams = {
  client_project_id: number;
};

export const documentsService = {
  getDocuments: async (params?: GetDocumentsParams) => {
    return await fetcher(`/documents/all`, {
      method: "GET",
      params,
      schema: officialDocumentsSchema,
    });
  },
};
